import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Row,
  Col,
  Container,
  Alert,
  Input,
  Button,
  Card,
  CardBody,
} from 'reactstrap';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

import saigeLogo from '../images/saige.jpg';      // <-- update path if needed

export function LoginPage() {
  const [username, setUsername]     = useState('');
  const [password, setPassword]     = useState('');
  const [errorMessage, setErrorMsg] = useState('');
  const navigate                    = useNavigate();

  /* -------------------- AUTH -------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const cred = await signInWithEmailAndPassword(auth, username.trim(), password);
      localStorage.setItem('username', cred.user.email);
      const idToken = await cred.user.getIdToken();
      localStorage.setItem('idToken', idToken);
      localStorage.setItem('authUser', cred.user.email);
      navigate('/dashboard');
    } catch (err) {
      setErrorMsg(err.message || 'Login failed');
    }
  };

  /* -------------------- UI -------------------- */
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: '100vh', background: 'radial-gradient(#202a44, #0d1528)' }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={4}>
            <Card className="shadow-lg border-0">
              {/* Header / Avatar */}
              <div
                style={{
                  background: 'linear-gradient(145deg, #1f3b70, #162447)',
                  paddingTop: '4.5rem',
                }}
                className="position-relative text-center"
              >
                <img
                  src={saigeLogo}
                  alt="Saige logo"
                  className="rounded-circle shadow"
                  style={{
                    width: 96,
                    height: 96,
                    objectFit: 'cover',
                    position: 'absolute',
                    top: '-48px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    border: '4px solid #fff',
                    backgroundColor: '#fff',
                  }}
                />
                <h5 className="text-white mt-4 mb-1">Welcome Back</h5>
                <p className="text-white-50 mb-0">Sign in to continue to Saige</p>
              </div>

              <CardBody className="p-4">
                {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <Input
                      type="email"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      placeholder="Email Address"
                      required
                      bsSize="lg"
                    />
                  </div>
                  <div className="mb-3">
                    <Input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Password"
                      required
                      bsSize="lg"
                    />
                  </div>

                  <div className="d-grid">
                    <Button color="primary" size="lg" type="submit">
                      Log In
                    </Button>
                  </div>

                  <div className="text-center mt-3">
                    <Link to="/forgot-password" className="text-decoration-none text-muted">
                      <i className="mdi mdi-lock me-1" /> Forgot password?
                    </Link>
                  </div>
                </form>
              </CardBody>
            </Card>

            <p className="text-center text-muted mt-4 mb-0">
              © {new Date().getFullYear()} Saige
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default LoginPage;


